<kl-alert
  [type]="alertType"
  [message]="alertMessage"
  [show]="alertShow"
></kl-alert>
<div id="filterSet">
  <div class="left-group ml-4">
    <form #filterForm="ngForm" class="form-inline">
      <div class="form-group row" style="width: 308px; position: relative">
        <label for="currency_date">Kur Tarihi </label>
        <button
          class="btn btn-sm ml-1 mr-1"
          [disabled]="disabledButton"
          (click)="changeDates('backward')"
        >
          <i class="fal fa-chevron-circle-left"></i>
        </button>
        <p-calendar
          id="currency_date"
          name="currency_date"
          dateFormat="dd/mm/yy"
          (onSelect)="calendarSelect($event)"
          utc="true"
          [showIcon]="true"
          [showButtonBar]="true"
          [(ngModel)]="today"
        ></p-calendar>
        <button
          class="btn btn-sm ml-1 mr-1"
          style="position: absolute; right: 0"
          [disabled]="disabledButton"
          (click)="changeDates('forward')"
        >
          <i class="fal fa-chevron-circle-right"></i>
        </button>
      </div>
    </form>
  </div>
  <div class="right-group">
    <div dropdown container="body">
      <!-- Toolbar buttons -->
      <button dropdownToggle type="button" class="btn btn-bluefish btn-sm">
        {{ "processes" | translate }}
        <i class="fal fa-download" aria-hidden="true"></i>
      </button>
      <ul
        class="dropdown-menu kl-dropdown"
        role="menu"
        *dropdownMenu
        placement="bottom left"
        container="body"
      >
        <li role="menuitem">
          <a class="dropdown-item" (click)="getCurrency('tcmb')"
            >TCMB'den Kurları Getir</a
          >
        </li>
        <li role="menuitem">
          <a class="dropdown-item" (click)="getCurrency('yesterday')"
            >Bir Önceki Günün Kurlarını Kopyala</a
          >
        </li>
      </ul>
      <button class="btn btn-greenish btn-sm" (click)="updateCurrency()">
        <i class="fal fa-plus"></i>
        {{ "edit" | translate }}
      </button>
    </div>
  </div>
  <div class="clearfix"></div>
</div>
<div>
  <div class="grid-content" style="padding: 0 3px">
    <div style="overflow: auto">
      <wj-flex-grid
        #currencyGrid
        [itemsSource]="collectionView"
        [selectionMode]="'Row'"
        [deferResizing]="false"
        (keydown)="onFlexKeyPress(currencyGrid, $event)"
        [headersVisibility]="'Column'"
      >
        <wj-flex-grid-column
          [header]="'Döviz Kodu'"
          [isReadOnly]="true"
          [binding]="'code'"
          [width]="'*'"
        >
        </wj-flex-grid-column>
        <wj-flex-grid-column
          [header]="'Döviz Adı'"
          [isReadOnly]="true"
          [binding]="'description'"
          [width]="'*'"
        >
        </wj-flex-grid-column>
        <wj-flex-grid-column
          [header]="'Döviz Alış'"
          [binding]="'currency_exchange_rates[0].purchase_amount'"
          [width]="'*'"
          [format]="'c4'"
        >
        </wj-flex-grid-column>
        <wj-flex-grid-column
          [header]="'Döviz Satış'"
          [binding]="'currency_exchange_rates[0].sales_amount'"
          [width]="'*'"
          [format]="'c4'"
        >
        </wj-flex-grid-column>
        <wj-flex-grid-column
          [header]="'Efektif Alış'"
          [binding]="'currency_exchange_rates[0].effective_purchase_amount'"
          [width]="'*'"
          [format]="'c4'"
        >
        </wj-flex-grid-column>
        <wj-flex-grid-column
          [header]="'Efektif Satış'"
          [binding]="'currency_exchange_rates[0].effective_sales_amount'"
          [width]="'*'"
          [format]="'c4'"
        >
        </wj-flex-grid-column>
      </wj-flex-grid>
    </div>
  </div>
</div>
